// import EasyMDE from "easymde";
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
// tslint:disable-next-line: no-submodule-imports
import { renderToStaticMarkup } from 'react-dom/server';
import { SimpleMdeReact } from 'react-simplemde-editor';

import { MarkdownContent } from '../markdown-content/markdown-content';
// import { uniqueId } from "../../../util/utils";

// tslint:disable-next-line: no-import-side-effect
import './easy-markdown-editor.css';

interface SimpleMDEReactContainerProps {
  autoSave?: boolean;
  initialContent?: string;
  addTableToToolbar?: boolean;
  onImageUpload?(file: File, onSuccess: (url: string) => void, onError: (msg: string) => void): void;
  preview?: boolean;
  onChange?(value: string): void;
}

@observer
export class SimpleMDEReactContainer extends React.Component<SimpleMDEReactContainerProps> {
  @observable contents: string;
  @observable options = {
    /// ===== [ These are the defaults we are definitely using: ] =============
    // --- [ Image/URL handling ] --------------------------------------
    // errorMessages: {
    //    fileTooLarge: "Image #image_name# is too big (#image_size#).\nMaximum file size is #image_max_size#.",
    //    importError: "Something went wrong when uploading the image #image_name#.",
    //    noFileGiven: "You must select a file.",
    //    typeNotAllowed: "This image type is not allowed."
    //  }
    // errorCallback: defaults to msg => alert(msg)
    // imageAccept: "image/png, image/jpeg"
    // imageMaxSize: 2097152 (1024*1024*2)
    // imageTexts: {
    //    sbInit: "Attach files by drag and dropping or pasting from clipboard.",
    //    sbOnDragEnter: "Drop image to upload it.", sbOnDrop: "Uploading image #images_names#...",
    //    sbOnDrop: "Uploading image #images_names#...",
    //    sbOnUploaded: "Uploaded #image_name#",
    //    sbProgress: "Uploading #file_name#: #progress#%",
    //    sizeUnits: " B, KB, MB"
    //  }
    // imageUploadFunction: false
    //    (input params (file, callbacks onSuccess(image URL), onError(errorMsg)))
    //  setting this renders imageMaxSize, imageAccept, imageUploadEndpoint and imageCSRFToken ineffective.
    // promptURLs: not set (false)
    // promptTexts: { image: "URL of the image:", link: "URL for the link:" }
    // uploadImage: false (true - enabled from Image icon)
    // imagePathAbsolute: not set (affects filePath result value from imageUploadEndpoint)
    // imageUploadEndpoint: not set (asynchronous POST request).
    //   The server saves image, and returns json:
    //   success: (HTTP 200-OK): {"data": {"filePath": "<filePath>"}}
    //   fail: {"error": "<errorCode>"}, errorCode = noFileGiven (HTTP 400), typeNotAllowed (HTTP 415), fileTooLarge (HTTP 413) or importError:
    //   If errorCode is not one of the errorMessages, it is alerted unchanged (server side error message)
    // imageCSRFToken: not set (sent to server)
    // -----------------------------------------------------------------
    // insertTexts: {
    //    HorizontalRule: [ "", "\n\n-----\n\n" ],
    //    image: [ "![](", "#url#)" ],
    //    link: [ "[", "](#url#)" ],
    //    table: [ "", "\n\n| Column 1 | Column 2 | Column 3 |\n| -------- | -------- | -------- |\n| Text     | Text     | Text     |\n\n" ],
    //    uploadedImage: [ "![](#url#)", "" ]
    //  }
    // toolbar: [
    // { name: "bold", className: "fa fa-bold", title: "Bold", action: EasyMDE.toggleBold(editor), default: true },
    // { name: "italic", className: "fa fa-italic", title: "Italic", action: EasyMDE.toggleItalic(editor), default: true },
    // { name: "heading", className: "fa fa-header fa-heading", title: "Heading", action: EasyMDE.toggleHeadingSmaller(editor), default: true },
    // "|",
    // { name: "quote", className: "fa fa-quote-left", title: "Quote", action: EasyMDE.toggleBlockQuote(editor), default: true },
    // { name: "unordered-list", className: "fa fa-list-ul", title: "Generic List", action: EasyMDE.toggleUnorderedList(editor), default: true },
    // { name: "ordered-list", className: "fa fa-list-ol", title: "Numbered List", action: EasyMDE.toggleOrderedList(editor), default: true },
    // "|",
    // { name: "link", className: "fa fa-link", title: "Create Link", action: EasyMDE.drawLink(editor), default: true },
    // { name: "image", className: "fa fa-image", title: "Insert Image", action: EasyMDE.drawImage(editor), default: true },
    // "|",
    // { name: "preview", className: "fa fa-eye", noDisable: true, action: EasyMDE.togglePreview(editor), default: true, title: "Toggle Preview" },
    // { name: "side-by-side", className: "fa fa-columns", noDisable: true, action: EasyMDE.toggleSideBySide(editor), default: true, title: "Toggle Side By Side", noMobile: true  },
    // { name: "fullscreen", className: "fa fa-arrows-alt", noDisable: true, action: EasyMDE.toggleFullScreen(editor), default: true, title: "Toggle Fullscreen", noMobile: true },
    // "|",
    // { name: "guide", action: "https://www.markdownguide.org/basic-syntax/", className: "fa fa-question-circle", noDisable: true, title: "Markdown Guide", default: true },
    // "|"
    // }
    // previewRender: previewRender(plaintext)
    /// ===== [ These might be useful: ] ======================================
    // previewImagesInEditor: false
    // lineNumbers: false
    // parsingConfig: (editor md parsing) Documented values don't appear to match what's in memory:
    //   doc: parsingConfig: { allowAtxHeaderWithoutSpace: false, strikethrough: true, underscoresBreakWords: false}
    //   mem: parsingConfig: { gitHubSpice: false, highlightFormatting: true, name: "gfm" }
    // renderingConfig: (previewer md parsing) not set
    //   see notes at https://github.com/Ionaru/easy-markdown-editor - this might be useful, though we will be using
    //   a different MD component to display
    // shortcuts: {
    // cleanBlock: "Cmd-E",
    // drawImage: "Cmd-Alt-I",
    // drawLink: "Cmd-K",
    // toggleBlockquote: "Cmd-'",
    // toggleBold: "Cmd-B",
    // toggleCodeBlock: "Cmd-Alt-C",
    // toggleFullScreen: "F11",
    // toggleHeadingBigger: "Shift-Cmd-H",
    // toggleHeadingSmaller: "Cmd-H",
    // toggleItalic: "Cmd-I",
    // toggleOrderedList: "Cmd-Alt-L",
    // togglePreview: "Cmd-P",
    // toggleSideBySide: "F9",
    // toggleUnorderedList: "Cmd-L"
    // } These might be system-specific ("Cmd" on Mac) so leave alone
    // syncSideBySidePreviewScroll: not set (true)
    //   Note: Leaving this to "true" causes a console warning:
    //         This site appears to use a scroll-linked positioning effect.
    //         This may not work well with asynchronous panning;
    //         see https://firefox-source-docs.mozilla.org/performance/scroll-linked_effects.html
    //         for further details and to join the discussion on related tools
    //         and features!
    /// ===== [ For the rest see the end of the file ] ========================
  };
  uniqueId?: string;
  toolbarOptions = [
    ['bold', 'italic', 'heading'],
    ['quote', 'unordered-list', 'ordered-list'],
    ['link', 'image'],
    ['preview', 'side-by-side', 'fullscreen'],
    ['guide']
  ];
  toolbarSeparator = '|';

  constructor(props: Readonly<SimpleMDEReactContainerProps>) {
    super(props);
    this.contents = props.initialContent ? props.initialContent : '';
    // FIXME local storage persists across reloads...
    // TODO when do we ignore local storage?
    // TODO how do we clear local storage when done?

    if (props.addTableToToolbar) {
      this.toolbarOptions[1].push('table', 'clean-block');
    }

    if (props.onImageUpload) {
      this.options = {
        ...this.options,
        uploadImage: true,
        imageUploadFunction: props.onImageUpload,
        imagePathAbsolute: true,
        imageTexts: {
          sbInit: 'Attach files by drag and drop, pasting from clipboard, or clicking Import an Image icon.'
        },
        insertTexts: {
          uploadedImage: ['![', '](#url#)']
        }
      };
      this.toolbarOptions[2] = ['link', 'upload-image'];
    }

    if (props.autoSave) {
      if (!this.uniqueId) {
        // "skillseeker-mde-dev-storybook"
        this.uniqueId = 'ssmde-dev-sb';
      }
      // SimpleMdeReact prepends "smde_" to the ID
      const autoSaved = localStorage.getItem('smde_' + this.uniqueId);
      if (autoSaved) {
        this.contents = autoSaved;
      }
      this.options = {
        ...this.options,
        autosave: {
          enabled: true,
          uniqueId: this.uniqueId
          // delay = default 10sec
          // submit_delay = default 10sec
          // timeformat locale:en-US,format: hour:minute
          // text "Autosaved: "
        }
      };
    }

    if (props.preview) {
      this.options = {
        ...this.options,
        previewRender: this.preview
      };
    }

    const toolbar = this.toolbarOptions.reduce((arr, next) => {
      if (arr.length === 0) {
        return arr.concat(next);
      }
      return arr.concat([this.toolbarSeparator]).concat(next);
    }, []);

    this.options = {
      ...this.options,
      toolbar
    };
    if (props.onChange) {
      props.onChange(this.contents);
    }
  }

  // Needed to extract contents from editor
  @action
  getContents = (value: string) => {
    this.contents = value;
    if (this.props.onChange) {
      this.props.onChange(this.contents);
    }
  };

  preview = (value: string) => {
    return renderToStaticMarkup(<MarkdownContent text={value} />);
  };

  render() {
    return (
      <SimpleMdeReact value={this.contents} onChange={this.getContents} id={this.uniqueId} options={this.options} />
    );
  }
}

/// ===== [ Other EasyMDE options (and defaults) which may be useful ] ========
// autofocus: false
// autosave: { enabled: false }
// autoRefresh: not set
// blockstyles: { bold: "**", italic: "*", code: "```" }
// scrollbarStyle: native
// element: (whatever is set by React MDE)
// forceSync: false
// hideIcons: not set
// indentWithTabs: true
// initialValue: (set by SimpleMdeReact)
// lineWrapping: true
// minHeight: 300px
// maxHeight: undefined
// onToggleFullScreen: not set
// overlayMode: not set
// placeholder: not set
// previewClass: "editor-preview"
// spellChecker: not set (doc says default to true)
// nativeSpellcheck: not set (doc says default to true)
// inputStyle: not set
// sideBySideFullscreen: not set (defaults to true)
// status: [ "autosave", "lines", "words", "cursor" ]
// styleSelectedText: not set (true)
// tabSize: not set (2)
// theme: not set ("easymde")
// toolbarTips: not set (true)
// direction: not set (ltr)



// WEBPACK FOOTER //
// ./src/ui/widgets/easy-markdown-editor/easy-markdown-editor.tsx